import * as React from "react";
import { BillingAccount } from "../../../schema/types/account";
import { Alert, Button } from "antd";
import { DOCS_URL } from "../../../envVariables";
import { ExternalLink } from "../../../newcomponents/table/components/ExternalLink";
import { useNavigate } from "react-router-dom";

interface Props {
  account: BillingAccount;
}
export const AccountDetailSetupPaymentMethod: React.FC<Props> = ({ account }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-10">
      <div className="mb-4 text-2xl">Thank you for creating an account.</div>
      {account.enabled === false ? (
        <Alert
          type={`info`}
          message={`Info`}
          description={
            <div>
              Your account is not activated yet. Please wait until customer support enables your account, or contact
              support at{" "}
              <a className="color-link" href={"mailto:support@controlplane.com"}>
                support@controlplane.com
              </a>{" "}
              if you need further help.
            </div>
          }
        />
      ) : null}
      <div>An account:</div>
      <ul>
        <li className="ml-8 list-disc">Is responsible for the billing</li>
        <li className="ml-8 list-disc">
          Can contain multiple <ExternalLink url={`${DOCS_URL}/concepts/org`} label="orgs" disableCopy />
        </li>
        <li className="ml-8 list-disc">Can be managed by multiple users</li>
        <li className="ml-8 list-disc">
          Requires a valid payment method to create an{" "}
          <ExternalLink url={`${DOCS_URL}/concepts/org`} label="org" disableCopy />
        </li>
      </ul>
      <div className="mt-2  ">
        Refer to the <ExternalLink url={DOCS_URL} label="documentation" disableCopy /> for more information.
      </div>
      <Button
        type={`primary`}
        className={"mt-6 action"}
        onClick={() => navigate(`/home/account/${account.id}/payment-methods`)}
      >
        Add a payment method
      </Button>
    </div>
  );
};
